import { UserService } from "../services/user/user.service";
import { store } from "../store/store";

export const SET_GROUPS_OF_USER = "SET_GROUPS_OF_USER";

export const fetchGroupsOfUser = async (userId: any) => {
  if (userId === undefined) return;
  const res = await UserService.getGroups(userId);
  store.dispatch(setGroupsOfUser(res.data));
};

export const setGroupsOfUser = (data: any) => {
  return {
    type: SET_GROUPS_OF_USER,
    data,
  };
};
